import { render, staticRenderFns } from "./AddAcount.vue?vue&type=template&id=1084ef30"
import script from "./AddAcount.vue?vue&type=script&lang=js"
export * from "./AddAcount.vue?vue&type=script&lang=js"
import style0 from "./AddAcount.vue?vue&type=style&index=0&id=1084ef30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports